import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
}

export const getters = {}

export const mutations = {
    SET_VROOMSCHEDULES(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[objects[key].id] = objects[key]
            } else if (state.objects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.objects, objects[key].id)
            }
        }
        state.objects = {
            ...updatedObjects,
        }
        // console.log(state.objects)

    },
    SET_VROOMSCHEDULE(state, objects) {
        state.currentVroomSchedule = objects
    },
}

export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },

    async vroomById({ commit }, { id } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query VroomById($Id: ID!) {
                    vroomById(id: $Id) {
                      id
                      status
                      date
                      estimated_cost
                      estimated_duration
                      unassigned_collections {
                        id
                        client{
                            client_name
                        }
                        site{
                            address
                        }
                      }
                      runsheets {
                        id
                        vehicle_id
                        route_steps
                        geometry
                      }
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                `,
                variables:{ Id: id }
            })
            commit('SET_VROOMSCHEDULE', response.data.vroomById)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async vroomByDate({ commit }, { date } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query VroomByDate($Date: String!) {
                    vroomByDate(date: $Date) {
                      id
                      status
                      date
                      estimated_cost
                      estimated_duration
                      unassigned_collections {
                        id
                        client{
                            client_name
                        }
                        site{
                            address
                        }
                      }
                      runsheets {
                        id
                        vehicle_id
                        route_steps
                        geometry
                      }
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                `,
                variables:{ Date: date }
            })
            commit('SET_VROOMSCHEDULE', response.data.vroomByDate)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
     // findOrCreateVroomSchedule hasn't been set up fully in backend yet
    async findOrCreateVroomSchedule({ commit, dispatch }, {id, status, date, estimatedCost, estimatedDuration, unassignedCollections, runsheets, } = {}) {
        try {
            // let that = this
            await graphqlClient.mutate({
                mutation: gql`
                mutation findOrCreateVroomSchedule($Id: ID $Status: String $Date: String $EstimatedCost: String $EstimatedDuration: String $UnassignedCollections: ID $Runsheets: ID)  {
                  findOrCreateVroomSchedule(client:{id: $Id status: $Status estimated_cost: $EstimatedCost estimated_duration: $EstimatedDuration unassigned_collections: $UnassignedCollections runsheets: $Runsheets}) {
                    id
                  }
                }
                `,
                variables: {Id: id, Status: status, Date: date, EstimatedCost: estimatedCost,EstimatedDuration: estimatedDuration,UnassignedCollections: unassignedCollections,Runsheets: runsheets},
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
}
